module.exports = __webpack_public_path__ + "static/media/Baseball-diamond-icon.e08098ff.svg";